import { type GA4 } from "./interfaces";

export async function sendPurchaseDatalayerEvent(payload: GA4.PurchasePayload) {
  window.gtag({ ecommerce: null });

  window.gtag({
    event: "purchase",
    ecommerce: payload,
  });
}
